import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {AnnouncementContainerVo} from '../../common/shared/api/nicolas/vo/AnnouncementContainerVo.interface';
import {AnnouncementTarget} from '../../graphql/generated/types';
import {AnnouncementTargetToParamMap} from './constant';

/**
 * 공지 목록 조회
 *
 * Origin: pageNicolasApi.getNoticeList
 * API: GET api/v1/app/notice/list
 * 공지가 별로 없어 통으로 가져옴(구 pageweb 부터 api 와 협의된 내용인데 일단은 next 에도 변동없이 감)
 */
export async function getAppNoticeList(
  {
    page = 0,
    size = 10000,
    target,
  }: {
    page?: number;
    size?: number;
    target: AnnouncementTarget;
  },
  options?: FetcherOptions
): Promise<AnnouncementContainerVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/app/notice/list',
    {
      method: 'GET',
      params: {
        page,
        size,
        target: AnnouncementTargetToParamMap[target],
      },
    },
    options
  );
  return response.data;
}
